import { Card, Group } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import templateWizardFormDefaults from '../../constants/templateWizardFormDefaults';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';
import TemplateForm from './TemplateForm';

const TemplatesNewForm = ({ from, onSuccess, onBack }) => {
  const fetch = useFetch();

  const [loadError, setLoadError] = useState();
  const [userError, setUserError] = useState();

  const [template, setTemplate] = useState();
  const { accountId, domainId } = useParams();

  useEffect(() => {
    if (from) {
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/templates/${from}`)
        .then(({ template }) => {
          if (!template.wizardFormData) {
            template.wizardFormData = templateWizardFormDefaults;
          }
          template.name = `Copy of ${template.name}`;
          delete template.id;
          setTemplate(template);
        })
        .catch(setLoadError);
    } else {
      setTemplate({
        name: 'New layout',
        type: 'recommender',
        body: '',
        advancedEditor: false,
        wizardFormData: templateWizardFormDefaults,
        recommenders: [],
        emailTemplates: [],
      });
    }
  }, [accountId, domainId, fetch, from]);

  const create = (template) => {
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/templates`, {
      method: 'POST',
      body: JSON.stringify(template),
    })
      .then(({ template }) => {
        onSuccess(template);
      })
      .catch(setUserError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!template) {
    return <Spinner />;
  }

  return (
    <>
      <Card withBorder>
        <Card.Section inheritPadding py="sm">
          <TemplateForm template={template} saveTemplate={create} cancel={onBack} />
        </Card.Section>
      </Card>
      {userError && (
        <Group justify="flex-end">
          <ErrorMessage message={userError.message} />
        </Group>
      )}
    </>
  );
};

export default TemplatesNewForm;
